import { render } from "./BreadcrumbsComp.vue?vue&type=template&id=6837ca46"
import script from "./BreadcrumbsComp.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__